import { Offer } from 'src/common/types/models/Offer'
import { atom } from 'jotai'
import { OffersManagementTab } from 'src/modules/OffersManagement/components/types'

interface OfferModalState {
  offer: Offer | null
  open: boolean
}

export const sharedOfferAtom = atom<Offer | null>(null)
export const editOfferAtom = atom<OfferModalState>({ offer: null, open: false })
export const activeTabAtom = atom<OffersManagementTab>('all')
export const preselectedMyOfferIdAtom = atom<string | null>(null)
